/**
 * Stylizes an item's price for preview purposes.
 * (i.e. the price that appears beside an item before it's clicked)
 */

export function PricePreviewFilter() {
    /**
     * getStylizedPrice(): Returns a string representing the price of an item
     *  -> Currently money symbol _not_ i18n
     *  -> Either uses item's price or a range in the format "$<min>-$<max>"
     *  @param item
     */
    var getStylizedPrice = function(item) {
        var i,
            min,
            max,
            stylizedPrice = '';

        if ((item.prices == undefined || item.prices.length === 0) &&
                item.hasOwnProperty('price') &&
                item.price !== 0.0) {
            // Just get the single price available
            stylizedPrice = '$' + item.price.toFixed(2);
        } else if (item.hasOwnProperty('prices') && item.prices.length > 0) {
            // Implies that there are multiple prices, create a min -> max range
            // Create a range with format "$min-$max"
            max = item.prices[0].price;
            min = item.prices[0].price;
            for (i = 1; i < item.prices.length; i++) {
                if (item.prices[i].price > max) {
                    max = item.prices[i].price;
                } else if (item.prices[i].price < min) {
                    min = item.prices[i].price;
                }
            }

            // do not display anything if price is 0
            if (max === min && max !== 0.0) {
                // If there's only one price, no range is needed
                stylizedPrice = '$' + item.prices[0].price.toFixed(2);
            } else if (max !== 0.0) {
                stylizedPrice = '$' + min.toFixed(2) + '\u2014$' + max.toFixed(2);
            }
        }

        return stylizedPrice;
    };

    return getStylizedPrice;
}
